import { formatNumber } from '#helpers/formatNumbers.js';
import { getClientByDocument } from '#services/client.js';
import { getInvoicesByUser } from '#services/invoice.js';
import { registerVoucher, updateFileVoucher } from '#services/voucher.js';
import { subtractDate } from '#utils/date.js';
import { fileToBase64 } from '#utils/file.js';
import { differenceInDays } from 'date-fns';
//const differenceInDays = () => null;
import { useEffect, useState } from 'react';

const PaymentStatus = ({ user, isAuth }) => {
  const [totalBalance, setTotalBalance] = useState(0);
  const [invoices, setInvoices] = useState(null);
  const [statusColor, setStatusColor] = useState('');
  const [invoiceDue, setInvoiceDue] = useState(null);
  const [messageSuccess, setMessageSuccess] = useState(null);
  const [messageError, setMessageError] = useState(null);

  const statementAcount = async () => {
    const client = await getClientByDocument(user.document_number);

    const invoicesData = await getInvoicesByUser(client.ID);

    //Calcular el total del saldo pendiente que tiene el cliente
    const balance =
      invoicesData.length > 0
        ? invoicesData.reduce((acc, item) => acc + Number(item.Saldo), 0)
        : 0;
    setTotalBalance(balance);

    //Lista y formateo de objecto de las facturas proximas a vencer

    if (invoicesData.length > 0) {
      const formatInvoices = invoicesData.map((invoice) => {
        //Calcular las fechas para traer los dias que le falta a la factiura para vencer
        const subtractedDates = subtractDate();
        const invoiceIssueDate = new Date(invoice.Fecha_de_Emision);

        //Diferencia de dias entre la fecha con plazo y la de emisión
        const differenceDays = differenceInDays(
          invoiceIssueDate,
          subtractedDates,
        );

        if (differenceDays > 7) {
          setStatusColor('green');
        } else if (differenceDays > 0) {
          setStatusColor('yellow');
        } else if (differenceDays <= 0) {
          setStatusColor('red');
        }

        return {
          id: invoice.ID,
          invoiceNumber: invoice.DocumentoNumero,
          daysExpire: differenceDays,
          client: invoice.Cliente,
          balance: invoice.Saldo,
          total: invoice.Total,
          issueDate: invoice.Fecha_de_Emision,
        };
      });

      const orderFormatInvoices = formatInvoices.sort(
        (a, b) => a.daysExpire - b.daysExpire,
      );
      setInvoiceDue(orderFormatInvoices[0]);
      setInvoices(orderFormatInvoices || null);
    } else {
      console.log('No tienes facturas en el sistema');
    }

    //Diferencias de dias
  };

  const sendVoucher = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const data = Object.fromEntries(formData.entries());


    if (data.Comprobante.name.length === 0) {
      setMessageError('Agregar comprobante');  
      return;
     }

    if (data.Referencia.length === 0) {
      setMessageError('La referencia no puede estar vacía');  
      return;
     }
    
    if (data.Monto.length === 0) {
      setMessageError('El monto no puede estar vacío');
      return;
    }
    
    if (data.Fecha.length === 0) {
      setMessageError('La fecha no puede estar vacía');
      return;
    }
    
    
    const { Comprobante:_, ...dataText } = data;

    try {
      const newVoucher = await registerVoucher(dataText);

      const labelBase64 = await fileToBase64(data.Comprobante);
      const fileName = data.Comprobante.name;

      const updateVoucher = await updateFileVoucher({
        idVoucher: newVoucher.data.ID, 
        label: labelBase64,
        fileName
      });

      if (updateVoucher.message === 'Data Updated successfully') 
        setMessageSuccess('El comprobante se registro correctamente.');
      else
        setMessageSuccess('Error al registrar el comprobante');

    } catch (error) {
      setMessageSuccess('Error al registrar el comprobamte');
      console.log('Error al registrar el comprobante');
    }
  };

  useEffect(() => {
    if (isAuth) {
      statementAcount();
    }
  }, []);

  return (
    <div className="section payment-status">
      {invoices && invoices.length > 0 ? (
        <div className="container">
          <div className="row">
            <div className="col col-100">
              <h2 className="title">Estado de cuenta</h2>
            </div>
          </div>
          <div className="row">
            <div className="col col-100">
              <h3 className="subtitles">Mi estado de cuenta</h3>
            </div>
            <div className="col col-25 col-mb-100">
              <div className="card">
                Saldo total pendiente: ${formatNumber(totalBalance)}
              </div>
            </div>
            <div className="col col-25 col-mb-100">
              <div className="card">
                <b>
                  Factura proxima a vencer:{' '}
                  {invoiceDue && invoiceDue.invoiceNumber}
                </b>
                <p>Vence en: {invoiceDue && invoiceDue.daysExpire} días</p>

              </div>
            </div>
            <div className="col col-50 col-mb-100">
              <table className="table-invoice-due">
                <thead>
                  <th>Numero de factura</th>
                  <th>Total</th>
                  <th>Saldo</th>
                  <th>Fecha de emision</th>
                  <th>Vence en</th>
                </thead>
                <tbody>
                  {invoices &&
                    invoices.length > 0 &&
                    invoices
                      .map((invoice) => (
                        <tr key={invoice.ID}>
                          <td>{invoice.invoiceNumber}</td>
                          <td>${formatNumber(invoice.total)}</td>
                          <td>${formatNumber(invoice.balance)}</td>
                          <td>{invoice.issueDate}</td>
                          <td>{invoice.daysExpire} días</td>
                        </tr>
                      ))
                      .slice(0, 5)}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="col col-100">
              <h3 className="subtitles">Pagar por transferencia</h3>
            </div>
            <div className="col col-33 col-mb-100">
              <div className="card">
                <b>Pagar por transferencia</b>
                <ul>
                  <li>
                    <b>Banco:</b> Bancolombia
                  </li>
                  <li>
                    <b>Tipo:</b> Corriente
                  </li>
                  <li>
                    <b>N° de cuenta:</b> {process.env.REACT_APP_N_CUENTA}
                  </li>
                  <li>
                    <b>Titular: </b> {process.env.REACT_APP_TITULAR}
                  </li>
                  <li>
                    <b>NIT: </b> {process.env.REACT_APP_NIT}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-33 col-mb-100">
              <div className="card">
                <b>QR</b>
                <div className="image-status">
                  {/* <img src="https://i.postimg.cc/6q11ZgmX/Commons-QR-code.png" /> */}
                </div>
              </div>
            </div>
            <div className="col col-33 col-mb-100">
              <div className="card">
                <b>Comprobante</b>
                <form onSubmit={sendVoucher}>
                  <input
                    name="Comprobante"
                    type="file"
                    className="form-control"
                  />

                  <input
                    name="Referencia"
                    type="text"
                    className="form-control"
                    placeholder="Número de referencia"
                  />
                  <input
                    name="Monto"
                    type="text"
                    className="form-control"
                    placeholder="Monto"
                  />
                  <input
                    name="Fecha"
                    type="date"
                    className="form-control"
                    placeholder="fecha"
                  />
                  <input
                    name=""
                    type="submit"
                    className="btn btn-blue"
                    value="Enviar Comprobante"
                  />
                </form>
                {messageSuccess ? (
                  <div className='message-success'>
                    {messageSuccess}
                  </div>
                ) : messageError ? (
                  <div className='error-form'>
                    {messageError}
                  </div>
                ) : ('')}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col col-100">
              <div className="cont-message">
                <div className="message">
                  <i className="fa-regular fa-circle-check"></i>
                  <h3>No tienes facturas pendientes</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentStatus;
